import {onMounted} from "vue";

export const useSvgTooltips = (svg) => {
  onMounted(() => {
    svg.value.querySelectorAll('[data-bs-toggle="tooltip"]')
      .forEach(g => {
        new bootstrap.Tooltip(g)
      })
  })
};
